export const SALES_EMAIL_ADDRESS = 'sales@highpeakssolutions.com';
export const SUPPORT_EMAIL_ADDRESS = 'support@highpeakssolutions.com';
